export default __webpack_public_path__ + "static/media/X-logo.09470474.svg";